// Imports
import Vue from 'vue'
import Router from 'vue-router'
import { trailingSlash } from '@/util/helpers'
import casl from '../services/auth'
import {
  layout,
  route,
} from '@/util/routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    layout('Default', [
      route('Accueil'),
      route('Dashboard', null, 'test'),
      // Pages
      route('Mon Profil', null, 'participant/profile'),
      route('Mes Classes', null, 'participant/classes'),
      route('Mes Travaux', null, 'participant/travaux'),
      route('Admin Inscriptions', 'admin', 'admin/inscriptions'),
      // Singulis
      route('Documents Singulis', 'documents', 'documents/singulis/'),
      route('Documents Omnibus', 'documents', 'documents/omnibus/'),

    ]),
    layout('Account', [
      route('AccountLogin', 'account', 'login', { guest: true }),
      route('AccountLogout', 'account', 'logout', { guest: true }),
      route('AccountSignin', 'account', 'signin', { guest: true }),
      route('AccountSigninConfirm', 'account', 'signin/confirm', { guest: true }),
      route('AccountSigninDone', 'account', 'signin/done', { guest: true }),
      route('AccountPasswordRequest', 'account', 'password/request', { guest: true }),
      route('AccountPasswordReset', 'account', 'password/reset', { guest: true }),
    ], '/account'),
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.guest)) {
    next()
  } else {
    casl.isLogged()
      .then(() => {
        to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
      })
      .catch(() => {
        next('/account/login')
      })
  }
})

export default router
